/* eslint-disable no-underscore-dangle */
import React from 'react'
import { onButtonTriggerKey } from '../../utils'

export type SectorOutlookCellProps = {
  cellProps: any
  isPrintPreview?: boolean
  handleClick: () => void
}

export const sectorOutlookFilter = (filterItem: any, data: any) => {
  const filter = filterItem.value.toLowerCase()
  const { sectorOutlook } = data._original
  return sectorOutlook && sectorOutlook.toLowerCase().includes(filter)
}

export const SectorOutlookCell = (props: SectorOutlookCellProps) => {
  const { cellProps, handleClick, isPrintPreview = false } = props
  const { sectorOutlookCode = '', sectorOutlook = '' } = cellProps.original
  return (
    <>
      {sectorOutlookCode ? (
        <div className="frw-ratings-key">
          {isPrintPreview ? (
            `${sectorOutlook}`
          ) : (
            <span
              aria-label={`Open popup for sector outlook keys. Current outlook: ${sectorOutlook}`}
              role="button"
              className={`frw-${sectorOutlookCode}`}
              onClick={handleClick}
              onKeyDown={onButtonTriggerKey(handleClick)}
              tabIndex={0}
              style={{ cursor: 'pointer' }}
            />
          )}
        </div>
      ) : null}
    </>
  )
}
export default SectorOutlookCell
